<template>
    <v-col
        :class="[
            `sub-content-block sub-content-block-${id}`,
            ...subBlock.appearance.base.cssClass,
            ...subBlock.appearance.theme[theme].cssClass,
            ...appearance.cssClass
        ]"
        :style="{
            ...subBlock.appearance.base.cssStyle,
            ...subBlock.appearance.theme[theme].cssStyle,
            ...appearance.cssStyle
        }"
    >
        <Suspense>
            <component
                :is="components[blockName]"
                :config="subBlock.config"
                :breakpoint="breakpoint"
                :breakpoint-name="breakpointName"
                :theme="theme"
                :is-mobile="isMobile"
                :is-hyperlink-block="isHyperlinkBlock"
            ></component>
        </Suspense>
    </v-col>
</template>

<script lang="ts" setup>
    import type {
        BreakpointType,
        ContentSubBlockComponentProps,
        ContentSubBlockComponentType
    } from '~/types';
    import {
        ContentBlockThemeStyleItems,
    } from '~/types';
    import { startCase as lo_startCase } from 'es-toolkit';
    import { legacyContentHelpers } from '~/composables';


    const components: Record<ContentSubBlockComponentType, Nullable<ReturnType<typeof resolveComponent>>> = {
        BlockTypeText: resolveComponent('ContentBlocksBlockTypeText'),
        BlockTypeImageStatic: resolveComponent('ContentBlocksBlockTypeImageStatic'),
        BlockTypeVideoStatic: resolveComponent('ContentBlocksBlockTypeVideoStatic'),
        BlockTypeInlineVideo: resolveComponent('ContentBlocksBlockTypeInlineVideo')
    };

    const props = withDefaults(
        defineProps<ContentSubBlockComponentProps>(),
        {
            id: 'desktop',
            theme: 'light',
            breakpoint: 'desktop',
            breakpointName: 'md'
        }
    );

    const { getAppearance } = legacyContentHelpers;
    const blockName = computed<ContentSubBlockComponentType>(() => `BlockType${lo_startCase(props.subBlock.type).replace(/\s/g, '')}` as ContentSubBlockComponentType);

    const appearance = computed<ContentBlockThemeStyleItems>(() => {
        const current: BreakpointType = props.breakpointName;
        const appearance = props.subBlock.appearance;

        return getAppearance(appearance, current);
    });
</script>

<style lang="scss" scoped></style>
